import { useTranslation } from 'react-i18next';

import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';

import CloseIcon from 'assets/close-green.svg?react';
import BeggingHuman from 'assets/png/begging-human.png?format=webp;avif&as=picture';

const RevengeInvitationModal = ({
  setOpen,
  invitedRoomId,
  className = '',
  onAcceptInvite,
  isLoading,
}: {
  setOpen: (open: boolean) => void;
  invitedRoomId: number | null;
  className?: string;
  onAcceptInvite: (roomId: number) => void;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`${className} flex w-[90%] animate-fast-appear justify-center gap-2 rounded-[20px] border-[0.5px] border-solid border-[#FFFFFF1A] bg-revenge-modal-gradient py-3 pr-3 sm:py-5 sm:pr-5`}
    >
      <OptimizedImage
        imageData={BeggingHuman}
        alt="begging human"
        className="h-[6.75rem] w-[6.75rem] xl:h-[13.5rem] xl:w-[13.5rem]"
      />
      <div className="relative w-full">
        <div className="flex w-full flex-col items-start justify-between">
          <div className="mb-5 flex flex-col items-start">
            <h2 className="mb-1 text-base font-[900] uppercase leading-[20px] text-white [-webkit-text-stroke-color:#001037] [-webkit-text-stroke-width:1px] sm:text-2xl sm:leading-[32px]">
              {t('modals.revengeInvitationModal.title')}
            </h2>
            <p className="text-sm font-normal leading-4 text-white sm:text-base">
              {t('modals.revengeInvitationModal.subTitle')}
            </p>
          </div>
          <PrimaryButton
            text={t('modals.revengeInvitationModal.accept')}
            onClick={() => onAcceptInvite(invitedRoomId)}
            buttonType="accept"
            className="w-full"
            isLoading={isLoading}
          />
        </div>
        <button className="absolute right-0 top-0" onClick={() => setOpen(false)}>
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default RevengeInvitationModal;
